import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../theme";
import { useSelector } from "react-redux";
import { reducerPaths } from "../../../app/reducerPaths";
import logoWithoutText from "../../../components/assets/logo-without-text.svg";
import { getRGBAFromColor } from "../../../utils/methods/getCssVariables";
import { getCommaFormattedPrice } from "../../../utils/methods/stringMethods";
import { localAuction } from "../../../utils/constants/auction";

const BidHistorySection = ({ 
  selectedCar,
  bids,
  isLoading
}) => {

  const isMobile = useMediaQuery("(max-width:1700px)");

  const auth = useSelector(store => store[reducerPaths.auth]);

  console.log(bids, selectedCar, `BidHistorySection`)

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" component="h2" sx={{ mb: 2, fontWeight: "bold", color: theme.palette.primary.main }}>
        Bid History
      </Typography>
      {typeof isLoading === "boolean" && isLoading ? (
        <CircularProgress />
      ) : (
        bids?.length === 0 ? (
          <Typography 
            sx={{ 
              fontSize: "1.25rem",
              fontWeight: "bold", color: theme.palette.text.primary }}>
            No bids yet
          </Typography>
        ) : (
          <TableContainer component={Paper} variant="outlined"
            sx={{
              maxHeight: "400px"
            }}
          >
            <Table>
              <TableBody>
                <TableRow sx={{ bgcolor: "black" }}>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Bid Amount
                  </TableCell>
                  <TableCell sx={{ 
                      textAlign: `${isMobile ? "left" : "right"} !important`,
                      color: "white", fontWeight: "bold" 
                    }}
                  >
                    Date-Time
                  </TableCell>
                </TableRow>
                {bids?.map((bid, index) => (
                  <TableRow key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? 
                        theme.palette.background.paper :
                        getRGBAFromColor({
                          color: theme.palette.text.primary,
                          alpha: "0.1"
                        }),
                      "& td": {
                        padding: "0.5rem 0.75rem !important"
                      }
                    }}
                  >
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box
                          component="img"
                          src={bid?.bidderIcon || logoWithoutText}
                          alt="Bidder"
                          sx={{ width: 30, mr: 1 }}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "600"
                            }}
                          >
                            ${getCommaFormattedPrice(bid?.amount)}
                          </Typography>

                          <Typography>
                            {selectedCar && "auction_type" in selectedCar && selectedCar?.auction_type === localAuction ? (
                              "Dealer ID"
                            ) : (
                              "Buyer ID"
                            )}: {bid?.dealerId} {auth?.user_id === bid?.dealerId ? "(You)" : ""}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell>{isMobile ? (
                      <Typography>
                        {bid.dateTime}
                      </Typography>
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end"
                        }}
                      >
                        <Typography>
                          {bid.dateTime?.split?.(" ")?.[0]}
                        </Typography>
                        <Typography>
                          {bid.dateTime?.split?.(" ")?.[1]}
                        </Typography>
                      </Box>
                      
                    )}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )
        
      )}
    </Box>
  )

  
};

export default BidHistorySection;
